import ArrowTopRightOnSquareIcon from '@heroicons/react/24/outline/ArrowTopRightOnSquareIcon';
import { Order } from 'shared/types/cart';
import Link from 'components/gruenland/atoms/link';
import OrderData from 'components/gruenland/molecules/order/OrderData';
import { useFormat } from 'helpers/hooks/useFormat';

interface Props {
  order: Order;
  shippingInfo: string;
}

const OrderShippingDetails: React.FC<Props> = ({ order, shippingInfo }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  return (
    <>
      <OrderData
        label={formatMessage({
          id: 'order.deliveryMethod',
          defaultMessage: 'Metodo di spedizione',
        })}
        className="mt-2"
      >
        {shippingInfo}
      </OrderData>

      <OrderData
        label={formatMessage({
          id: 'order.shippingAddress',
          defaultMessage: 'Indirizzo di spedizione',
        })}
        className="mt-2"
      >
        {order.custom?.fields?.shippyProPickupPointId ? (
          <>
            <p>{order.shippingAddress?.company ?? order.custom.fields.shippyProPickupPointName}</p>
            <p>{order.custom.fields.shippyProPickupPointAddress}</p>
            {order.custom.fields.shippyProPickupPointCourier && (
              <p>{order.custom.fields.shippyProPickupPointCourier}</p>
            )}
          </>
        ) : (
          <>
            {order.shippingAddress?.company && <p>{order.shippingAddress.company}</p>}
            <p>{`${order.shippingAddress?.firstName ?? ''} ${order.shippingAddress?.lastName ?? ''}`}</p>
            <p>{`${order.shippingAddress?.streetName}, ${order.shippingAddress?.city}, ${order.shippingAddress?.postalCode}`}</p>
            {order.shippingAddress?.additionalAddressInfo && <p>{order.shippingAddress.additionalAddressInfo}</p>}
          </>
        )}

        {order.trackingUrl && (
          <Link link={order.trackingUrl} target="_blank" rel="noopener" className="mt-2 flex gap-1">
            {formatMessage({
              id: 'order.trackingUrl',
              defaultMessage: 'Link di tracciamento',
            })}
            <ArrowTopRightOnSquareIcon width={17.5} strokeWidth={2} />
          </Link>
        )}
      </OrderData>
    </>
  );
};

export default OrderShippingDetails;
